import React, { useState, useContext, useEffect } from 'react';
import list from '../products.json';
import { CartContext } from '../context/ShopingCartContext';
import { Item } from './Item';
import axios from 'axios'
import Swal from 'sweetalert2';
const ProductsList = () => {
  const [domicilio, setDomicilio] = useState({ domicilio: false, message: '' });
  const [aclaracion, setAclaracion] = useState({ aclaracion: false, message: '' });
  const {enviadoAclaracion, setEnviadoAclaracion} = useContext(CartContext); 
  const {enviadoDomicilio, setEnviadoDomicilio} = useContext(CartContext);
  const [para, setPara] = useState({ value: '', saved: false });
  const {enviadoPara, setEnviadoPara} = useContext(CartContext);
  const { cart, setCart } = useContext(CartContext);

// Function to check for days from previous month
// Function to check for days from previous month
const checkPreviousMonthDays = async () => {
  try {
    // Fetch days data
    const response = await axios.post(`${import.meta.env.VITE_IP}/getAllday`);
    const daysData = response.data;
    
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();
    
    // Flag to track if we found days from previous month
    let hasPreviousMonthDays = false;
    
    // Check each day in the fetched data
    for (let i = 0; i < daysData.length; i++) {
      if (daysData[i].data) {
        // Parse the date in format "YYYY-MM-DD"
        const dateParts = daysData[i].data.split('-');
        if (dateParts.length === 3) {
          const dayYear = parseInt(dateParts[0]);
          const dayMonth = parseInt(dateParts[1]) - 1; // JS months are 0-11
          
          // Check if this day is from previous month
          if ((dayMonth < currentMonth && dayYear === currentYear) || 
              (dayMonth === 11 && currentMonth === 0 && dayYear === currentYear - 1)) {
            hasPreviousMonthDays = true;
            break;
          }
        }
      }
    }
    
    // Show alert if previous month days exist
    if (hasPreviousMonthDays) {
      Swal.fire({
        title: '¡Atención!',
        text: 'Hay días del mes anterior. Recuerda cerrar el mes.',
        icon: 'warning',
        confirmButtonText: 'Entendido'
      });
    }
  } catch (error) {
    console.error("Error checking for previous month days:", error);
  }
};

// Call this function when the component mounts
useEffect(() => {
  checkPreviousMonthDays();
}, []); // Empty dependency array to run only once when component mounts

// Call this function when the component mounts
useEffect(() => {
  checkPreviousMonthDays();
}, []); // Empty dependency array to run only once when component mounts

  const addToCart = (newItem) => {
    if(stateCheck()){
      const existingItemIndex = cart[0].cart.findIndex((item) => item.hasOwnProperty(Object.keys(newItem)[0]));
      let modifquedCart = cart;
      if (existingItemIndex !== -1) {
        const updatedCart = [...modifquedCart[0].cart];
        const existingItem = updatedCart[existingItemIndex];
        updatedCart[existingItemIndex] = { ...existingItem, ...newItem };
        modifquedCart[0].cart = updatedCart
        setCart(modifquedCart);
      } else {
        modifquedCart[0].cart.push(newItem)
        setCart(modifquedCart);
      }
    }else{
    const existingItemIndex = cart.findIndex((item) => item.hasOwnProperty(Object.keys(newItem)[0]));
    if (existingItemIndex !== -1) {
      const updatedCart = [...cart];
      const existingItem = updatedCart[existingItemIndex];
      updatedCart[existingItemIndex] = { ...existingItem, ...newItem };
      setCart(updatedCart);
    } else {
      setCart([...cart, newItem]);
    }}
  };
  
  const stateCheck = () => {
    const tieneCart = cart.some(objeto => Object.keys(objeto).indexOf('cart') !== -1);
    return tieneCart ? true : false;
  
  };
  

  const handleEnviarAclaracionClick = () => {
  setAclaracion({ ...aclaracion, saved: true });
  addToCart({ aclaracion });
  setEnviadoAclaracion(true);
  };

const handleEnviarDomicilioClick = () => {
  setDomicilio(domicilio);
  setEnviadoDomicilio(true);
  addToCart({ domicilio });
};

const handleEnviarParaClick = () => {
  setPara({ ...para, saved: true });
  setEnviadoPara(true);
  addToCart({ para });
};
  const handleDomicilioChange = (event) => {
    const { checked } = event.target;
    setDomicilio({ domicilio: checked, message: '' });
  };
  
  const handleAclaracionChange = (event) => {
    const { value } = event.target;
    setAclaracion({ ...aclaracion, message: value });
  };
  

  const handleTextAreaChange = (event) => {
    const { value } = event.target;
    setDomicilio({ ...domicilio, message: value });
  };


  const handleParaInputChange = (event) => {
    const { value } = event.target;
    setPara({ value, saved: false });
  };

  return (
    <div>
      <br />
      <div className="form-check form-switch">
        <input
          className="form-check-input"
          type="checkbox"
          id="flexSwitchCheckDefault"
          checked={domicilio.domicilio}
          onChange={handleDomicilioChange}
        />
        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
          Domicilio
        </label>
      </div>
      {domicilio.domicilio && !enviadoDomicilio && (
        <div className="form-floating">
          <textarea
            className="form-control"
            placeholder="Escriba su dirección aquí"
            value={domicilio.message}
            onChange={handleTextAreaChange}
            style={{ height: '100px', marginTop: '10px' }}
          ></textarea>
          <label htmlFor="floatingTextarea">Dirección de entrega</label>
          <button type="button" className="btn btn-success" onClick={handleEnviarDomicilioClick}>
            Listo
          </button>
        </div>
      )}
      {domicilio.domicilio && enviadoDomicilio && (
        <div className="alert alert-success" role="alert">
          Dirección de entrega guardada
        </div>
      )}
      <div className="form-floating" style={{ marginTop: '20px' }}>
        <input
          type="text"
          className="form-control"
          id="paraInput"
          placeholder="Para:"
          value={para.value}
          onChange={handleParaInputChange}
        />
        <label htmlFor="paraInput">Para:</label>
        <button type="button" className="btn btn-success" onClick={handleEnviarParaClick}>
          Listo
        </button>
      </div>
      {enviadoPara && (
        <div className="alert alert-success" role="alert">
          Nombre guardado
        </div>
      )}
      <div className="form-floating" style={{ marginTop: '20px' }}>
        <textarea
          className="form-control"
          placeholder="Escriba una aclaración aquí"
          value={aclaracion.message}
          onChange={handleAclaracionChange}
          style={{ height: '100px', marginTop: '10px' }}
        ></textarea>
        <label htmlFor="floatingTextarea">Aclaración:</label>
        <button type="button" className="btn btn-success" onClick={handleEnviarAclaracionClick}>
          Listo
        </button>
      </div>
      {enviadoAclaracion && (
        <div className="alert alert-success" role="alert">
          Aclaración guardada
        </div>
      )}

<div className="product-grid">
      {list.productos.map((producto) => (
        <Item producto={producto} key={producto.id} />
      ))}
    </div>
    </div>
  );
};

export default ProductsList;
